import { useClaims } from "./useClaims";

const REQUIRED_GROUPS = [
  "bcba776b-ad66-4c3c-b253-a10a1b65c294", // Admins - TI
  "ccf4a2fb-4ccb-4292-ba83-6c565146e4f0", // Users - TI
  "1c4b0acb-3657-48c1-9024-0904307a94b7", // CEP - Admins
  "c7b622a4-bdb6-48b4-b39e-9f0970a9602f", // CEP - Users
  "64b8612b-1d6a-479b-a754-b318356dc908", // CEP - Operação
];

export default function AppGuard({ children }: { children: React.ReactNode }) {
  const claims = useClaims();
  const groups = claims?.groups ?? [];

  const hasAccess = REQUIRED_GROUPS.some((r) => groups.includes(r));

  // Enquanto o useClaims não terminou, mostra loading
  if (!claims.isReady) {
    return (
      <div className="h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center text-slate-600 animate-pulse">
          <div className="h-10 w-10 mx-auto border-4 border-slate-300 border-t-emerald-600 rounded-full animate-spin mb-4"></div>
          <p className="text-sm">Validando acesso … </p>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="h-screen flex items-center justify-center bg-slate-50">
        <div className="max-w-md w-full bg-white shadow-xl rounded-2xl p-8 text-center border border-slate-200">
          <div className="flex items-center justify-center w-16 h-16 mx-auto rounded-full bg-red-100 mb-4">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <h2 className="text-xl font-semibold text-slate-800">Acesso negado</h2>
          <p className="text-slate-600 mt-2">
            Você não tem permissão para acessar este sistema.
            <br />
            Em caso de dúvida, entre em contato com a equipe de TI.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
